import PropTypes from 'prop-types';

import Empty from '@zenbusiness/zui/Empty';

import ExpandableMenuItem from './ExpandableItem';
import LinkMenuItem from './LinkItem';
import { MenuItemProps } from './utils/contants';

/**
 * MenuItem
 *
 * @param {import('./MenuItem.ts').NavMenuItem} props
 *
 * @returns {import('react').ReactNode}
 */
function MenuItem(props) {
  const { path, url, links, onClick } = props;
  if (path || url) {
    return <LinkMenuItem {...props} />;
  }

  if (links) {
    return <ExpandableMenuItem {...props} onClick={(isParent = true) => onClick(isParent)} />;
  }

  return <Empty unsupported />;
}

MenuItem.propTypes = {
  ...MenuItemProps,
  expanded: PropTypes.bool,
  links: PropTypes.arrayOf(PropTypes.shape(MenuItemProps).isRequired),
};

export default MenuItem;
